// import axios from "./APIUtils";
import axios from "./axios.provider";
import { apiConfig } from "./config";
import { parseList } from "./utility";

const GetProjectList = async function(model) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/GetAllBiddingProject`,
      model
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const CreateProject = async function(model) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/AddBiddingProject`,
      model
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const CreateProjectItemTemplate = async function(model) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/AddBiddingProjectItemTemplate`,
      model
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const CreateProjectWeight = async function(model) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/AddBiddingProjectWeight`,
      model
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const GetProjectInfo = async function(id) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/BiddingProject/GetBiddingProject/${id}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const GetProjectTemplate = async function(id) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/BiddingProject/GetBiddingProject_ItemTemplate/${id}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const GetProjectWeight = async function(id) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/BiddingProject/GetBiddingProject_Weight/${id}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const GetProjectVendorCriteria = async function(id) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/BiddingProject/GetBiddingProject_VendorCriteria/${id}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const GetProjectSelectedVendor = async function(id) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/BiddingProject/GetBiddingProject_SelectedVendor/${id}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const FindVendorWithCriteria = async function(model) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/AddBiddingProjectVendorCriteria`,
      model
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const SubmitProjectSelectedVendor = async function(model) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/AddBiddingProjectSelectedVendor`,
      model
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const SubmitBiddingProject = async function(id) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/SubmitBiddingProject/${id}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const GetBlobFileProject = async function(filename, fileFullName) {
  try {
    axios({
      url: `${apiConfig}/api/Blob/GetBlobByBiddingProject/${filename}`,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", fileFullName);
      document.body.appendChild(fileLink);

      fileLink.click();
    });

    /* const response = await axios.get(
      `${apiConfig}/api/Blob/GetBlobByBiddingProject/${filename}`,
      "blob"
    );
    return response; */
  } catch (error) {
    console.log(error);
  }
};

const ApprovalProject = async function(model) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/BiddingProject_Approval`,
      model
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const GetBiddingProjectByStatus = async function(model) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/GetAllBiddingProjectWithWaitingApproval`,
      model
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const GetBiddingApprovalList = async function(model) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/GetAllBiddingProject_ApprovalList`,
      model
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const DeleteBiddingProject = async function(model) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/DeleteBiddingProject`,
      model
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const UpdatePrPo = async function(ProjectId, PrPo) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/UpdatePrPo?ProjectId=${ProjectId}&PrPo=${PrPo}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const getAllFileTor = async function(ProjectId) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/BiddingProject/GetAllAttachmentTOR/${ProjectId}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const getAllFileOther = async function(ProjectId) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/BiddingProject/GetAllAttachmentOther/${ProjectId}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const UploadFileTor = async function(model) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/UploadFileTOR`,
      model
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const UploadFileOther = async function(model) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/UploadFileOther`,
      model
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const DeleteFileTor = async function(model) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/DeleteFileTOR`,
      model
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const DeleteFileOther = async function(model) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/DeleteFileOther`,
      model
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
  }
};

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const _projectservices = {
  GetProjectList,
  CreateProject,
  toBase64,
  CreateProjectItemTemplate,
  CreateProjectWeight,
  GetProjectInfo,
  GetProjectTemplate,
  GetProjectWeight,
  GetProjectVendorCriteria,
  GetProjectSelectedVendor,
  FindVendorWithCriteria,
  SubmitProjectSelectedVendor,
  SubmitBiddingProject,
  GetBlobFileProject,
  ApprovalProject,
  GetBiddingProjectByStatus,
  GetBiddingApprovalList,
  DeleteBiddingProject,
  UpdatePrPo,
  getAllFileTor,
  getAllFileOther,
  UploadFileTor,
  UploadFileOther,
  DeleteFileTor,
  DeleteFileOther,
};
